import React, { useEffect, useState } from 'react';
import { Tusers } from '../../../type/users';
import { getChildren, updateMemberType } from '../../../service/usersService';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { setUser } from '../../../redux/utlsSlice';
import { MINIO } from '../../../data/data';
import { checkImageExists } from '../../../utls/img';
import DynamicFaIcon from '../../atoms/DynamicFaIcon';
import { initialOption, Toption } from '../../../type/option';
import { ModalMemberType } from '../Modal';
import { FormGroup } from '../../moleculs';
import { ButtonPrimary, ButtonSecondary, SelectDropDown } from '../../atoms';
import { showMessage } from '../../../utls/message';
import { getMemberType } from '../../../service/memberType';
import { TmemberType } from '../../../type/memberType';


interface CardOrgTwoProps {
    node: Tusers;
    onCollapse?: (users: Tusers) => void;
    collapsed?: boolean;
    edit?: boolean;
    onClick?: () => void
}
const CardOrgTwo = (props: CardOrgTwoProps) => {
    const { node, onCollapse, collapsed = false, edit = true } = props;
    const [nodeUsers, setNodeUsers] = useState<Tusers>(node);
    const { users } = useSelector((state: RootState) => state.reducer.utlsSlice);
    const [imagePreview, setImagePreview] = useState('');
    const [imageExists, setImageExists] = useState(false);
    const dispatch = useDispatch<any>();
    const [isOpen, setIsOpen] = useState(false);
    const [memberTypeList, setMemberTypeList] = useState<Toption[]>([]);
    const [selectMemberType, setSelectMemberType] =
        useState<Toption>(initialOption);

    const getMyDataProfile = async (uniqueId: string, callback?: (newUsers: Tusers) => void) => {
        const response = await getChildren(uniqueId);
        if (!response?.error) {
            const newNode: Tusers = response?.data;
            const newUsers = JSON.parse(JSON.stringify(users));
            const updateChildren = (nodes: Tusers[]) => {
                for (const item of nodes) {
                    if (item.uniqueId === uniqueId) {
                        item.children = newNode.children;
                        break;
                    } else if (item.children) {
                        updateChildren(item.children);
                    }
                }
            };
            if (newUsers.children) {
                updateChildren(newUsers.children);
            }
            if (callback) {
                callback(newUsers);
            }
        }
    };

    const loadImage = async () => {
        const imageUrl = `${MINIO}/${nodeUsers.thumbnail}`;
        if (nodeUsers.thumbnail != undefined) {
            const exists = await checkImageExists(imageUrl);
            setImageExists(exists);
            setImagePreview(
                exists ? imageUrl : '/assets/imgs/no-user-image-icon.jpg'
            );
        } else {
            setImagePreview('/assets/imgs/no-user-image-icon.jpg');
        }
    };

    useEffect(() => {
        loadImage();
        getDataMemberType('');
    }, [nodeUsers.thumbnail]);

    const onSubmit = async () => {
        if (!selectMemberType) {
            return showMessage('Member Type Wajib Diisi', 'error');
        }

        const data = {
            ...node
        };
        data.memberType = selectMemberType.data;

        const response = await updateMemberType(data);
        if (response?.code === 200) {
            showMessage(response?.message, 'success');
            setNodeUsers(data)
            setIsOpen(!isOpen);
        } else {
            showMessage(response?.message, 'error');
        }
    };

    const getDataMemberType = async (keyword: string) => {
        const data = {
            pageNo: 0,
            pageSize: 10,
            sortType: 'DESC',
            filter: [
                {
                    key: 'name',
                    value: keyword,
                    operation: 'MATCH',
                    conjunction: 'and',
                },
                {
                    key: 'active',
                    value: true,
                    operation: 'EQUAL',
                    conjunction: 'and',
                },
            ],
        };
        const response = await getMemberType(data);
        if (!response?.error) {
            const items: Toption[] = [];
            // eslint-disable-next-line array-callback-return
            response?.data.content.map((item: TmemberType) => {
                items.push({
                    label: item.name,
                    value: item.id?.toString() || '0',
                    data: item,
                });
            });
            setMemberTypeList(items);
        }
    };

    return (
        <>
            <div
                onClick={() => {
                    onCollapse && onCollapse(node);
                    if (edit) {
                        getMyDataProfile(node.uniqueId ?? '-', (newUsers) => {
                            dispatch(setUser(newUsers))
                        });
                    }
                }}
                className="relative cursor-pointer border-gray-300 inline-block border min-w-[180px] bg-white rounded-md p-3"
            >
                <div className="flex gap-2 items-center">
                    <div className="rounded-full bg-gray-300 overflow-hidden h-[40px] w-[40px] flex items-center justify-center">
                        <img
                            src={imagePreview}
                            className=" max-w-full"
                            alt=""
                        />
                    </div>
                    <div className="text-left">
                        <span className="p-0 m-0 block text-[11px] text-blue-400">
                            {nodeUsers?.memberType?.name}
                        </span>
                        <span className="p-0 m-0 block text-[12px]">{nodeUsers?.fullName}</span>
                        <span className="p-0 m-0 block text-[11px] text-gray-400">
                            {nodeUsers?.code}
                        </span>
                    </div>
                </div>
                {edit && (
                    <div
                        className="text-[14px] absolute right-2 top-2 text-blue-400"
                        onClick={() => {
                            setIsOpen(!isOpen);
                            setSelectMemberType({
                                label: nodeUsers?.memberType?.name || '',
                                value: nodeUsers?.memberType?.id?.toString() || '0',
                                data: nodeUsers?.memberType,
                            });
                        }}
                    >
                        <DynamicFaIcon name={'FaSquarePen'} />
                    </div>
                )}
            </div>
            <ModalMemberType
                isOpen={isOpen}
                onClose={() => {
                    setIsOpen(!isOpen);
                }}
            >
                <FormGroup label={'Member Type'}>
                    <SelectDropDown
                        options={memberTypeList}
                        value={selectMemberType}
                        menuPortalTarget={true}
                        onChange={(e) => {
                            setSelectMemberType(e);
                        }}
                        onInputChange={(e) => {
                            getDataMemberType(e);
                        }}
                    />
                </FormGroup>
                <div className="mt-10 mb-2 pt-4 flex justify-between gap-2 border-t">
                    <ButtonPrimary
                        onClick={() => {
                            onSubmit();
                        }}
                    >
                        Save
                    </ButtonPrimary>
                    <ButtonSecondary
                        onClick={() => {
                            setIsOpen(!isOpen);
                        }}
                    >
                        Close
                    </ButtonSecondary>
                </div>
            </ModalMemberType>
        </>
    );
};

export default CardOrgTwo;